import React from "react";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="container2Wrapper">
      <div class="container2">
        <h1>Privacy Policy</h1>
        <p>
          <strong>Effective Date:</strong> August 13, 2025
        </p>

        <h2>Table of Contents</h2>
        <ol>
          <li>
            <a href="#section1">Personal Information We Collect</a>
            <ol>
              <li>
                <a href="#section1-1">Categories of Personal Information</a>
              </li>
              <li>
                <a href="#section1-2">Sources of Personal Information</a>
              </li>
              <li>
                <a href="#section1-3">Special Data Collected via AI Surveillance</a>
              </li>
            </ol>
          </li>
          <li>
            <a href="#section2">How We Use Your Personal Information</a>
            <ol>
              <li>
                <a href="#section2-1">Purpose of Use</a>
              </li>
              <li>
                <a href="#section2-2">Lawful Basis for Processing (EEA & UK Residents)</a>
              </li>
            </ol>
          </li>
          <li>
            <a href="#section3">Third-Party Sharing and Disclosure</a>
            <ol>
              <li>
                <a href="#section3-1">Vendors, Partners, and Service Providers</a>
              </li>
              <li>
                <a href="#section3-2">Legal and Regulatory Requirements</a>
              </li>
              <li>
                <a href="#section3-3">Mergers, Acquisitions, and Business Transfers</a>
              </li>
            </ol>
          </li>
          <li>
            <a href="#section4">Data Retention</a>
            <ol>
              <li>
                <a href="#section4-1">Retention Schedules by Data Type</a>
              </li>
              <li>
                <a href="#section4-2">Legal and Compliance Retention Requirements</a>
              </li>
            </ol>
          </li>
          <li>
            <a href="#section5">Cookies, Tracking, and Marketing</a>
            <ol>
              <li>
                <a href="#section5-1">Types of Cookies and Tracking Technologies</a>
              </li>
              <li>
                <a href="#section5-2">Managing Cookies and Opt-Out Options</a>
              </li>
              <li>
                <a href="#section5-3">Targeted Advertising and AI Analytics</a>
              </li>
            </ol>
          </li>
          <li>
            <a href="#section6">User Rights</a>
            <ol>
              <li>
                <a href="#section6-1">EEA & UK Residents (GDPR)</a>
              </li>
              <li>
                <a href="#section6-2">California Residents (CCPA/CPRA)</a>
              </li>
              <li>
                <a href="#section6-3">Canada Residents (PIPEDA)</a>
              </li>
              <li>
                <a href="#section6-4">Other U.S. States and International Users</a>
              </li>
            </ol>
          </li>
          <li>
            <a href="#section7">Data Security</a>
            <ol>
              <li>
                <a href="#section7-1">Technical Measures</a>
              </li>
              <li>
                <a href="#section7-2">Organizational Measures</a>
              </li>
              <li>
                <a href="#section7-3">Employee Access and Training</a>
              </li>
              <li>
                <a href="#section7-4">Breach Notification Procedures</a>
              </li>
            </ol>
          </li>
          <li>
            <a href="#section8">International Data Transfers</a>
            <ol>
              <li>
                <a href="#section8-1">Transfers Outside Your Country</a>
              </li>
              <li>
                <a href="#section8-2">Adequacy Decisions and Standard Contractual Clauses</a>
              </li>
            </ol>
          </li>
          <li>
            <a href="#section9">AI Analytics, Automated Decision-Making, and Profiling</a>
          </li>
          <li>
            <a href="#section10">Industry-Specific Use Cases</a>
            <ol>
              <li>
                <a href="#section10-1">Retail Locations</a>
              </li>
              <li>
                <a href="#section10-2">Cafes & Restaurants</a>
              </li>
              <li>
                <a href="#section10-3">Fitness Centers</a>
              </li>
              <li>
                <a href="#section10-4">Tutoring Centers</a>
              </li>
            </ol>
          </li>
          <li>
            <a href="#section11">Children’s Privacy</a>
          </li>
          <li>
            <a href="#section12">Changes to This Privacy Policy</a>
          </li>
          <li>
            <a href="#section13">Contact Information</a>
          </li>
        </ol>

        <h2 id="section1">1. Personal Information We Collect</h2>
        <h3 id="section1-1">1.1 Categories of Personal Information</h3>
        <table className="table">
          <tr>
            <th>Category</th>
            <th>Examples</th>
            <th>Source</th>
          </tr>
          <tr>
            <td>Contact Information</td>
            <td>Name, email, phone, address, company</td>
            <td>Direct, Third Parties</td>
          </tr>
          <tr>
            <td>Account Information</td>
            <td>Login credentials, user ID, admin privileges</td>
            <td>Direct</td>
          </tr>
          <tr>
            <td>Billing & Payment</td>
            <td>Credit/debit card info, invoices, billing address</td>
            <td>Direct, Third Parties</td>
          </tr>
          <tr>
            <td>AI & Camera Data</td>
            <td>
              Video footage, facial recognition metadata, behavioral analytics, attendance, zone
              activity
            </td>
            <td>AI Surveillance, Automatic</td>
          </tr>
          <tr>
            <td>Device & Technical</td>
            <td>IP address, device type, browser, OS, cookies, GPS/location</td>
            <td>Automatic</td>
          </tr>
          <tr>
            <td>Telemetry & Usage</td>
            <td>Product usage, feature engagement, reports accessed</td>
            <td>Automatic</td>
          </tr>
          <tr>
            <td>Marketing Preferences</td>
            <td>Newsletter subscriptions, opt-in/opt-out preferences</td>
            <td>Direct, Third Parties</td>
          </tr>
          <tr>
            <td>Employment Information</td>
            <td>Role, title, department, staff activity logs</td>
            <td>Direct, Third Parties</td>
          </tr>
        </table>

        <h3 id="section1-2">1.2 Sources of Personal Information</h3>
        <ul>
          <li>
            <strong>Direct Collection:</strong> Registration, demo requests, purchases, support,
            account management.
          </li>
          <li>
            <strong>Third Parties:</strong> Affiliates, business customers, social media, marketing
            partners, public sources.
          </li>
          <li>
            <strong>Automatic Collection:</strong> Cookies, tracking pixels, AI analytics, device
            identifiers, IP addresses, geolocation.
          </li>
        </ul>

        <h3 id="section1-3">1.3 Special Data Collected via AI Surveillance</h3>
        <ul>
          <li>
            <strong>Visual Data:</strong> Facial recognition, body measurements, uniforms,
            distinctive features.
          </li>
          <li>
            <strong>Behavioral Patterns:</strong> Queue times, movement tracking, task completion,
            interactions.
          </li>
          <li>
            <strong>Audio Data:</strong> Alarms, announcements, safety sounds (where permitted).
          </li>
          <li>
            <strong>Device Metadata:</strong> Camera serial numbers, software versions, timestamps,
            logs.
          </li>
        </ul>

        <h2 id="section2">2. How We Use Your Personal Information</h2>
        <h3 id="section2-1">2.1 Purpose of Use</h3>
        <table className="table">
          <tr>
            <th>Purpose</th>
            <th>Personal Data Used</th>
            <th>Legal Basis</th>
          </tr>
          <tr>
            <td>Deliver Services</td>
            <td>Contact info, account info, AI data</td>
            <td>Contract, Legitimate Interest</td>
          </tr>
          <tr>
            <td>Security & Safety</td>
            <td>AI & camera data, telemetry, account info</td>
            <td>Legitimate Interest, Legal Obligation</td>
          </tr>
          <tr>
            <td>Billing & Transactions</td>
            <td>Billing/payment info, contact info</td>
            <td>Contract, Legal Obligation</td>
          </tr>
          <tr>
            <td>Analytics & Reporting</td>
            <td>Telemetry, usage data, AI insights</td>
            <td>Legitimate Interest</td>
          </tr>
          <tr>
            <td>Marketing & Communication</td>
            <td>Contact info, preferences</td>
            <td>Consent, Legitimate Interest</td>
          </tr>
          <tr>
            <td>Compliance & Legal</td>
            <td>All relevant personal data</td>
            <td>Legal Obligation, Legitimate Interest</td>
          </tr>
          <tr>
            <td>Research & AI Optimization</td>
            <td>AI data, telemetry</td>
            <td>Legitimate Interest</td>
          </tr>
        </table>

        <h3 id="section2-2">2.2 Lawful Basis for Processing (EEA & UK)</h3>
        <ul>
          <li>
            <strong>Consent:</strong> Explicit user agreement for processing.
          </li>
          <li>
            <strong>Legitimate Interests:</strong> Necessary for services, security, or operations.
          </li>
          <li>
            <strong>Contract Performance:</strong> Fulfillment of service agreements.
          </li>
          <li>
            <strong>Legal Compliance:</strong> Regulatory or statutory obligations.
          </li>
        </ul>

        <h2 id="section3">3. Third-Party Sharing and Disclosure</h2>
        <h3 id="section3-1">3.1 Vendors, Partners, and Service Providers</h3>
        <table className="table">
          <tr>
            <th>Recipient Type</th>
            <th>Data Shared</th>
            <th>Purpose</th>
          </tr>
          <tr>
            <td>Cloud Hosting & Storage</td>
            <td>AI, camera, telemetry, billing</td>
            <td>Service delivery</td>
          </tr>
          <tr>
            <td>Analytics & AI Vendors</td>
            <td>Aggregated AI data, telemetry</td>
            <td>Model improvement, reporting</td>
          </tr>
          <tr>
            <td>Marketing Partners</td>
            <td>Contact info, preferences</td>
            <td>Communication, advertising</td>
          </tr>
          <tr>
            <td>Legal & Auditing</td>
            <td>Billing, AI logs, telemetry</td>
            <td>Compliance, audit</td>
          </tr>
          <tr>
            <td>Law Enforcement & Regulators</td>
            <td>AI data, contact info</td>
            <td>Legal obligation</td>
          </tr>
        </table>

        <h3 id="section3-2">3.2 Legal and Regulatory Requirements</h3>
        <p>Disclosure may occur under court orders, subpoenas, or legal mandates.</p>

        <h3 id="section3-3">3.3 Mergers, Acquisitions, and Business Transfers</h3>
        <p>
          Personal information may transfer during mergers, acquisitions, or business sales to
          ensure continuity of services.
        </p>

        <h2 id="section4">4. Data Retention</h2>
        <h3 id="section4-1">4.1 Retention Schedules by Data Type</h3>
        <table className="table">
          <tr>
            <th>Data Type</th>
            <th>Retention Period</th>
            <th>Reason</th>
          </tr>
          <tr>
            <td>AI Camera Footage</td>
            <td>30–180 days (configurable)</td>
            <td>Operational & legal</td>
          </tr>
          <tr>
            <td>Billing & Payment</td>
            <td>7 years</td>
            <td>Tax/Accounting compliance</td>
          </tr>
          <tr>
            <td>Account Info</td>
            <td>Duration of account + 2 years</td>
            <td>Service continuity</td>
          </tr>
          <tr>
            <td>Telemetry & Analytics</td>
            <td>2 years</td>
            <td>Reporting & AI optimization</td>
          </tr>
          <tr>
            <td>Cookies & Tracking</td>
            <td>1–13 months</td>
            <td>Functional & marketing</td>
          </tr>
        </table>

        <h3 id="section4-2">4.2 Legal and Compliance Retention Requirements</h3>
        <p>Data may be retained longer if legally required or for dispute resolution.</p>

        <h2 id="section5">5. Cookies, Tracking, and Marketing</h2>
        <h3 id="section5-1">5.1 Types of Cookies and Tracking Technologies</h3>
        <ul>
          <li>
            <strong>Essential Cookies:</strong> Platform functionality.
          </li>
          <li>
            <strong>Analytical Cookies:</strong> Usage tracking, error reporting.
          </li>
          <li>
            <strong>Marketing Cookies:</strong> Personalized campaigns.
          </li>
          <li>
            <strong>Third-Party Cookies:</strong> Partner integrations.
          </li>
        </ul>

        <h3 id="section5-2">5.2 Managing Cookies and Opt-Out Options</h3>
        <p>
          Users can adjust browser settings or platform Cookie Settings to customize preferences.
        </p>

        <h3 id="section5-3">5.3 Targeted Advertising and AI Analytics</h3>
        <p>Cookies, SDKs, and other tools deliver interest-based ads; users can opt-out anytime.</p>

        <h2 id="section6">6. User Rights</h2>
        <h3 id="section6-1">6.1 EEA & UK Residents (GDPR)</h3>
        <ul>
          <li>
            Access, correct, delete, restrict processing, data portability, object to profiling.
          </li>
          <li>Withdraw consent anytime.</li>
          <li>Lodge complaints with supervisory authorities.</li>
        </ul>

        <h3 id="section6-2">6.2 California Residents (CCPA/CPRA)</h3>
        <ul>
          <li>
            Right to know, delete, correct, opt-out of sale/sharing, limit use of sensitive data.
          </li>
          <li>Non-discrimination for exercising rights.</li>
        </ul>

        <h3 id="section6-3">6.3 Canada Residents (PIPEDA)</h3>
        <ul>
          <li>Right to access and correct information.</li>
          <li>Consent required for collection, use, and disclosure.</li>
        </ul>

        <h3 id="section6-4">6.4 Other U.S. States and International Users</h3>
        <p>Rights vary by jurisdiction; Flowlinks.ai complies with local laws.</p>

        <h2 id="section7">7. Data Security</h2>
        <h3 id="section7-1">7.1 Technical Measures</h3>
        <ul>
          <li>Encryption at rest and in transit (AES-256, TLS 1.2+).</li>
          <li>Multi-factor authentication for admin access.</li>
          <li>Anonymization of AI logs where feasible.</li>
        </ul>

        <h3 id="section7-2">7.2 Organizational Measures</h3>
        <ul>
          <li>Restricted access by role.</li>
          <li>Vendor contracts requiring confidentiality.</li>
        </ul>

        <h3 id="section7-3">7.3 Employee Access and Training</h3>
        <ul>
          <li>Privacy training for employees.</li>
          <li>Access only to data necessary for roles.</li>
        </ul>

        <h3 id="section7-4">7.4 Breach Notification Procedures</h3>
        <ul>
          <li>Notification within 72 hours where legally required.</li>
          <li>Coordination with regulators and affected users.</li>
        </ul>

        <h2 id="section8">8. International Data Transfers</h2>
        <ul>
          <li>Data may be transferred globally.</li>
          <li>
            Transfers rely on EU adequacy, Standard Contractual Clauses (SCCs), or equivalent
            safeguards.
          </li>
        </ul>

        <h2 id="section9">9. AI Analytics, Automated Decision-Making, and Profiling</h2>
        <ul>
          <li>Automated alerts for safety, staff monitoring, and customer behavior.</li>
          <li>Human review ensures fairness, accuracy, and minimization.</li>
          <li>AI outputs used for operational and security purposes only.</li>
        </ul>

        <h2 id="section10">10. Industry-Specific Use Cases</h2>
        <h3 id="section10-1">10.1 Retail Locations</h3>
        <ul>
          <li>Customer behavior analysis, virtual lines, queue times, zone tracking.</li>
          <li>Staff monitoring, attendance, uniform compliance, refund/discount alerts.</li>
        </ul>

        <h3 id="section10-2">10.2 Cafes & Restaurants</h3>
        <ul>
          <li>Kitchen safety, hygiene alerts, queue monitoring, customer experience insights.</li>
          <li>Staff productivity and compliance tracking.</li>
        </ul>

        <h3 id="section10-3">10.3 Fitness Centers</h3>
        <ul>
          <li>Restricted area monitoring, equipment usage, cleanliness.</li>
          <li>Member traffic analysis, safety alerts.</li>
        </ul>

        <h3 id="section10-4">10.4 Tutoring Centers</h3>
        <ul>
          <li>Attendance tracking via AI facial recognition.</li>
          <li>Classroom activity reporting and incident alerts.</li>
        </ul>

        <h2 id="section11">11. Children’s Privacy</h2>
        <ul>
          <li>Services not directed at children under 13 (or local age of consent).</li>
          <li>No deliberate collection of children’s personal data.</li>
        </ul>

        <h2 id="section12">12. Changes to This Privacy Policy</h2>
        <ul>
          <li>Updates may occur anytime; users should review regularly.</li>
          <li>Changes posted with updated effective dates.</li>
        </ul>

        <h2 id="section13">13. Contact Information</h2>
        <p>
          Email: <a href="mailto:info@flowlinks.ai">info@flowlinks.ai</a>
        </p>
        <p>Mail: 3840 Park Avenue, STE C-205, Edison, NJ 08820</p>
        <p>Phone: +1 (732) 354-1541</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
